<template>
    <el-drawer
       :title="!id ? '添加城市' : '管理城市'"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content" v-loading="dataLoading">
            <el-form
                :model="formData"                
                ref="formData"               
            >				
				<el-form-item label="省份:">{{formData.provinceName}}</el-form-item>
				<el-form-item label="城市:">{{formData.name}}</el-form-item>				
				<el-form-item prop="display" label="状态:">
					<el-radio-group v-model="formData.homeDisplay" size="medium">
						<el-radio :label="1">显示</el-radio>
						<el-radio :label="0">隐藏</el-radio>
					</el-radio-group>
				</el-form-item>				
				<el-form-item prop="isHot" label="热门设置:" >					
					<el-checkbox v-model="formData.isHot" :true-label="1" :false-label="0">设置当前城市为热门城市</el-checkbox>
				</el-form-item>
				<el-form-item prop="cities" label="周边城市:">
					<div class="form-flex">
						<city-select :value.sync="formData.cities" :value-options="cityOptions" multiple :showNsationwide="false" ></city-select>
					</div>				    
				</el-form-item>
                <el-form-item prop="photo" label="城市照片:">
					<div class="form-flex">
						<image-upload 
                            :url.sync="formData.photo" 
                            :urlFull.sync="formData.photo" 
                        >
                            <span slot="size">图片建议尺寸750*540</span>
                        </image-upload>
					</div>				    
				</el-form-item>   
                <el-form-item prop="description" label="城市简介:">
					<div class="form-flex">
						<el-input type="textarea" v-model="formData.description" maxlength="200" :rows="4" show-word-limit></el-input>
					</div>				    
				</el-form-item>                
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" 
				:loading="btnLoading"
				@click="submitForm"
             >提交</el-button
            >
        </div> 
    </el-drawer>
</template>

<script>
import CitySelect from '@/components/CitySelect';
import ImageUpload from '@/components/ImageUpload';
const defaultFormData = {
    homeDisplay: 1,
    isHot:'',
    nearbyCity:'',
	cities: [],
    photo: "",
    description: ""
}
export default {
    components:{CitySelect, ImageUpload},
    data(){
        return{
            drawerShow: false,
            dataLoading: false,
            btnLoading:false,
            formData:{
				...defaultFormData
			},           
            id:'',			
			cityOptions: [],
			showNsationwide: { // 是否有全国选项
                type: Boolean,
                default: false
			}
		}
    },
   
    methods:{
        
        close() {            
            this.$refs['formData'].clearValidate();
            this.$refs['formData'].resetFields();
            this.drawerShow = false;
        },
        show(id) {
           this.id = id;
           if(this.id){
               this.getDetail();
           }
           this.drawerShow = true;
        },
		// 获取详情
		async getDetail() {
            this.dataLoading = true;
            const response = await this.$request({
                url: '/city/detail',
                method: "POST",
                params: { id: this.id },
            });
            const {msg, state, result} = response.data;
            this.btnLoading = false;
            if (state != 1) return this.$message.error(msg);
            this.dataLoading = false;
            if(result.cities) {
				const citiesIds= [];
				const cityOptions = [];
				if(result.cities.length > 0) {
					result.cities.forEach( item => {
						citiesIds.push(item.code);
						cityOptions.push({value: item.code, label:item.name});
					})
				}else {
					result.cities = ['0'];					
				}
				this.cityOptions = cityOptions;				
				this.formData.cities = citiesIds;
			} 
            delete result.cities
            this.formData = {...this.formData, ...result};
			
		},       
        // 表单提交
        submitForm() {
           let self = this;
           
           self.$refs["formData"].validate((valid) => {
               if (valid) {
                   
                   const _url = "/city/addOrUpdate";
                   this.btnLoading = true;                    
					
                   this.$request({
                       url: _url,
                       data: {
                            id:this.formData.id,
                            homeDisplay:this.formData.homeDisplay,
                            isHot:this.formData.isHot,
                            nearbyCity:this.formData.cities.toString(),
                            photo: this.formData.photo,
                            description: this.formData.description
                        },
                       method: "post",
                   })
                       .then((res) => {
                           const { state, msg } = res.data;
                           if (state == 1) {
                               this.$emit('update');
                               self.close();
                           } else {
                               self.$message.error(msg || "操作失败,请重试");
                           }
                       })
                       .catch(() => {
                           self.$message.error("操作失败,请重试");
                       })
                       .finally(() => {
                           this.btnLoading = false;
                       });
               } else {
                   return false;
               }
           });
                   
        }
    }
}
</script>

<style lang="scss" scoped>
.form-flex{
    width: 100%;
    overflow: hidden;
}
</style>